// HandleCache.vue
// Thin app-shell wrapper. Version/update detection is handled entirely by the
// service-worker lifecycle in registerServiceWorker.js (single source of truth).
<script setup>
import { ref, onMounted } from 'vue';

const isLoading = ref(true);
const isLatestVersionAvailable = ref(true);

// Manual escape hatch (kept for tooling): wipe caches and reload.
const clearCacheAndReload = () => {
  if ('caches' in window) {
    caches.keys().then((names) => {
      for (let name of names) caches.delete(name);
    });
  }
  window.location.reload();
};

onMounted(() => {
  isLoading.value = false;
});

defineExpose({
  clearCacheAndReload,
});
</script>

<template>
  <div>
    <slot :isLoading="isLoading" :isLatestVersionAvailable="isLatestVersionAvailable" />
  </div>
</template>
